import { createContext } from 'react';

export const BrandGroupingContext = createContext();
